import { Api } from "./Api.class";
const endpoint = "skills";
const skillsAPI = new Api(endpoint);
export default skillsAPI;
